import React from "react";
import { priceFormatFunc } from "@/helpers/stringFormat";
import commonStyle from "../../common/common.module.scss";
import { getHexCodeArray } from "@/helpers/plpHelper";

//THIS COMPONENT WILL BE USE FOR PLP DETAILS
export default function ProductListingDetails({variantsFinalOptions, product, randomId, moreInfo_tag, handlePLPSwatchHover, searchComp }) {
  let isSale = "";
  let formattedPrice = "";
  let showColorTag = false;
  const fastShipping = moreInfo_tag?.toLowerCase() === 'fast shipping'?<span class="fast_shipping_dot"></span>:"";
  const formatPrice = (price) => {
    // Check if the number is an integer or a decimal number
    if (Number.isInteger(price)) {
      // Format the number without decimal places if it's an integer
      formattedPrice = `$${new Intl.NumberFormat('en-US').format(price)}`;
    } else {
      // Format the number with two decimal places if it's a decimal number
      formattedPrice = `$${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(price)}`;
    }
    return formattedPrice;
  }

  const cancelledPrice = formatPrice(product.compare_at_price);
  const price = formatPrice(product.price);

  if (Number(product.compare_at_price)>Number (product.price)) {
    isSale = (
      <div className="hit-price-sale xx-small" id={`product-compare-price-${product.id}${randomId ? "-" + randomId : ""}`} style={{ textDecoration: "line-through" }}>
        {/* Price Format */}
        {priceFormatFunc(cancelledPrice)}
        {/* ${product.compare_at_price} */}
      </div>
    );
  }

  // Check if for the product color swatches have to be shown or not and also get the color hex code array
  let hexCodeArray = [];
  const variantGroup = product?.meta?.custom?.variant_grouping;
  // Check if the product has a variant group and if it contains the color name
  const colorName = variantGroup && variantGroup.split("-")?.length > 1 ? variantGroup.split("-")[1] : "";
  if(product.named_tags?.Tag1?.toLowerCase()?.includes('more colors available') && colorName) {
    hexCodeArray = getHexCodeArray(variantsFinalOptions).slice(0,5);
    showColorTag = true;
  }

  return (
    <>
      <div className="hit-content-wrap">
        <div className="hit-content-box">
          <div className="hit-brand small medium" id={`product-vendor-${product.id}${randomId ? "-" + randomId : ""}`}>{product.vendor}</div>
          <div className="hit-name x-small" id={`product-name-${product.id}${randomId ? "-" + randomId : ""}`}>{product.title}</div>
        </div>
        <div className={`hit-price-box ${isSale && searchComp ? "hit-price-box-sale" : ""}`}>
        <div className={`hit-price x-small medium ${isSale !== "" ? "final-sale-price-color" : ""}`} id={`product-price-${product.id}${randomId ? "-" + randomId : ""}`}>
            {/* Price Format */}
            {priceFormatFunc(price)}

          </div>
          {isSale}
        </div>
      </div>
      <p className={`xx-small-md xx-small-sm xx-small-xs italic plp-tag-2 plp-upper-case ${moreInfo_tag?.toLowerCase() === 'low stock' ? "plp-low-stock-tag" : ""} ${showColorTag && searchComp ? "plp-color-swatch-low-stock-tag" : ""}`}>{showColorTag && moreInfo_tag?.toLowerCase() === 'more colors available' ? "" : moreInfo_tag}{fastShipping}</p>
      {/* Color swatches */}
      {/* Show color swatched only when there are more than 1 color available */}
      {hexCodeArray.length > 1 && 
        hexCodeArray.map(({ colorName, hex }, index) => (
          <div className="swatches-item plp-swatches" key={index} onMouseEnter={()=>handlePLPSwatchHover(colorName)} onMouseLeave={()=>handlePLPSwatchHover("")}>
            <label
              className={`${
                variantGroup?.includes(colorName) ? "selectedVariant" : ""
              }`}
            >
              <span
                className={`swatches-type plp-size ${commonStyle.main}`}
                style={{ backgroundColor: `#${hex}` }}
              ></span>
            </label>
          </div>
        ))}
    </>
  );
}
